const receiptSessions = new Map<string, string>();
const storageKey = (intentID: string) => `wavemind:purchase-receipt:${intentID}`;

// Capture the return credential before marketing scripts read the page URL.
// Stripe returns it in the fragment so it never reaches server access logs.
export function capturePurchaseReceiptAccess() {
    const receiptWindow = window as Window & { __wavemindPurchaseReceipt?: { intentID: string; sessionID: string } };
    const captured = receiptWindow.__wavemindPurchaseReceipt;
    if (captured) {
        receiptSessions.set(captured.intentID, captured.sessionID);
        delete receiptWindow.__wavemindPurchaseReceipt;
    }
    const match = window.location.pathname.match(/^\/paymentSuccess\/[^/]+\/([^/]+)\/?$/);
    if (!match) return;
    const search = new URLSearchParams(window.location.search);
    const fragment = new URLSearchParams(window.location.hash.slice(1));
    const sessionID = fragment.get("session_id") || search.get("session_id");
    if (!sessionID) return;

    const intentID = match[1];
    receiptSessions.set(intentID, sessionID);
    try { sessionStorage.setItem(storageKey(intentID), sessionID); } catch { /* Storage blocked; use memory. */ }
    search.delete("session_id");
    fragment.delete("session_id");
    const query = search.toString();
    const hash = fragment.toString();
    window.history.replaceState(window.history.state, "", `${window.location.pathname}${query ? `?${query}` : ""}${hash ? `#${hash}` : ""}`);
}

export function getPurchaseReceiptAccess(intentID: string): string | null {
    capturePurchaseReceiptAccess();
    if (receiptSessions.has(intentID)) return receiptSessions.get(intentID)!;
    try { return sessionStorage.getItem(storageKey(intentID)); } catch { return null; }
}
